export default {
  setMigrationDialogHeader: 'Set start of migration',
  setMessage: 'The migration status of {count} {type} is reset, and all {type} are migrated again from {date}.',
  setMigrationDialogErrorPast: 'The date must be in the past',
};
